export function preloadAnalysisInsights(): void {
  void import(
    "@/app/(components)/specifics/tools/CallAnalysis/components/Analysis/components/AnalysisInsights/AnalysisInsights"
  );
}
